<template>
  <div class="login_bg">
    <div class="main d-flex align-items-center">
      <img class="close mt-5 mb-5 mx-auto" src="../assets/images/btn_close.png" @click="closeCardList" alt="">
    </div>
    <div class="container mx-auto" style="width: 80%;">
      <div class="cardList-Carousel">
        <Carousel class="row carousel row mx-auto" :autoplay="false" :paginationEnabled="false" :perPageCustom="[[480, 2], [768, 4]]" :centerMode="true" :navigationEnabled="true" :navigationNextLabel="''" :navigationPrevLabel="''" :navigationClickTargetSize="0">
          <Slide class="p-3" v-for="(card,index) in inputSelectedCard" :key="index">
            <img style="width: 100%;" class="mx-auto" :src="card.src" alt="">
          </Slide>
        </Carousel>
      </div>
    </div>

    <h5 class="my-2 mt-5">請使用APP中的AR辨識圖庫掃描辨識圖，即可看到酷炫擴增的時境動畫。</h5>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  name: 'SmallCardList',
  components: {
    Carousel,
    Slide
  },
  props: {
    inputSelectedCard: Array
  },
  methods: {
    closeCardList () {
      this.$emit('closeCardList', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .login_bg {
      width: 100%;
      height: 100%;
      background:rgba(0,0,0,0.9);
      position: fixed;
      color: #ffffff;
      z-index: 50;
      top: 0;
      left: 0;
      overflow-y: scroll;
      max-height: 100vh;

      h2 {
        color: #ffffff;
        margin: 0;
      }
      img {
        cursor: pointer;
      }
  }
  .main {
    margin-top: 80px;
  }
</style>
<style lang="scss" >
  .cardList-Carousel{
    .VueCarousel-navigation-prev::before{
      content: '';
      position: absolute;
      background: url('../assets/images/btn_arrow_L_white.png') no-repeat top left /30px 30px;
      z-index: 2;
      right: 20px;
      top: -25px;
      width: 30px;
      height: 30px;
    }
    .VueCarousel-navigation-next::before{
      content: '';
      position: absolute;
      background: url('../assets/images/btn_arrow_R_white.png') no-repeat top left /30px 30px;
      z-index: 2;
      top: -25px;
      left: 20px;
      width: 30px;
      height: 30px;
    }
  }
</style>
